export default "__VITE_ASSET__DzS7N2Rz__"